import React from 'react';
import _ from '@dh-fe/translate';
import SignUpButton from 'components/Button/SignUpButton';
import specialRequestOranum from './assets/specialRequestOranum.png';
import specialRequestOranumWebp from './assets/specialRequestOranum.webp';
import awardsPngOranum from './assets/oranum_awards.png';
import awardsWebpOranum from './assets/oranum_awards.webp';
import callPngOranum from './assets/callOranum.png';
import callWebpOranum from './assets/callOranum.webp';
import chatPngOranum from './assets/oranum_messanges.png';
import chatWebpOranum from './assets/oranum_messanges.webp';
import livePngOranum from './assets/liveOranum.png';
import liveWebpOranum from './assets/liveOranum.webp';
import storiesPngOranum from './assets/oranum_stories.png';
import storiesWebpOranum from './assets/oranum_stories.webp';
import referralOranum from './assets/oranum_referral.png';
import referralOranumWebp from './assets/oranum_referral.webp';
import surprisesOranum from './assets/oranum_surprises.png';
import surprisesOranumWebp from './assets/oranum_surprises.webp';

interface Item {
    image: string;
    imageCompress: string;
    title: string;
    share?: string;
    text: string;
    isVisible: boolean;
}

interface Content {
    items: Item[];
    button: JSX.Element;
}

const OranumContent: Content = {
    button: <SignUpButton>{_`Start creating!`}</SignUpButton>,
    items: [
        {
            image: callPngOranum,
            imageCompress: callWebpOranum,
            title: _`Video Call`,
            text: _`Enable Video Call and pick up the phone when it's ringing. Just by talking with your Members you can earn money in a price/minute rate. You decide that rate!`,
            isVisible: true,
        },
        {
            image: livePngOranum,
            imageCompress: liveWebpOranum,
            title: _`Mobile Live/Private`,
            text: _`Live Sessions are free live streams that let connect with your Members anytime, anywhere! Boost your earnings by convincing your Members to start a Private Show with you!`,
            isVisible: true,
        },
        {
            image: chatPngOranum,
            imageCompress: chatWebpOranum,
            title: _`Messenger`,
            text: _`With {site} every message counts! Reply to your Members in Messenger to earn more. Send special, personalized content like custom-made videos, photos... Best of all, you set the price!`.withData(
                { site: 'Oranum' },
            ),
            isVisible: true,
        },
        {
            image: storiesPngOranum,
            imageCompress: storiesWebpOranum,
            title: _`Stories`,
            text: _`Stories are a great way to show your followers your spiritual tools, routines, and magical rituals or simply share a daily card with some wisdom and advice. Mix it up and create both photos and videos detailing your methods and experiences, and keep your members coming back for more!`,
            isVisible: true,
        },
        {
            image: awardsPngOranum,
            imageCompress: awardsWebpOranum,
            title: _`Awards`,
            text: _`We appreciate our best Broadcasters! Whether you use Video Call, Messenger or Surprises to reach out, you'll earn points based on the amount of interactions. With up to {upTo} weekly prizes, you can reach an extra monthly income of {income}!`.withData(
                { upTo: '$2,000', income: '$8,000' },
            ),
            isVisible: true,
        },
        {
            image: specialRequestOranum,
            imageCompress: specialRequestOranumWebp,
            title: _`Special Requests`,
            text: _`You can offer your fans Special Requests during your live streams. Fulfill your Members wishes and keep them engaged! Choose which actions you want to perform, and set your own price for each one.`,
            isVisible: true,
        },
        {
            image: referralOranum,
            imageCompress: referralOranumWebp,
            title: _`Referral program`,
            text: _`Bring new friends to Oranum and get a {commission} commission on your friends’ earnings! The more broadcasters you refer, the more you will earn!`.withData(
                { commission: '10%' },
            ),
            isVisible: true,
        },
        {
            image: surprisesOranum,
            imageCompress: surprisesOranumWebp,
            title: _`Surprises`,
            text: _`By sending Surprises, your Members can express their happiness and appreciation for you. You can receive Surprises during Live Streams, Video Calls or even when you're offline. The more Surprises you get, the more you earn!`,
            isVisible: true,
        },
    ],
};

// eslint-disable-next-line import/prefer-default-export
export const getContent = (): Content => {
    return OranumContent;
};
